const tab_sections = {
    overview: 'Übersicht',
    authentication: 'Authentifizierung',
    authorization: 'Autorisierung',
    users: 'Benutzer',
    developer: 'Entwickler',
    tenant: 'Mieter',
};
export default Object.freeze(tab_sections);
